<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="title">Tackling the Team</h1>
<h2 class="subtitle">The Vassi Collection: Volume VI</h2>
<p class="author">Marco Vassi</p>
<p class="colophon _idGenParaOverride-1"><img alt="" class="_idGenPageitem-1" src="image/logo.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TacklingTheTeam.vue?2eb3fc0b